var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNotification = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  fill: "#1B1F23",
  "aria-hidden": "true",
  viewBox: "0 0 32 32"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18 3.175C23.895 4.253 27.183 10.31 27.939 21 29.657 21 31 22.343 31 24a3 3 0 0 1-3 3h-7.1a5.002 5.002 0 0 1-9.8 0H4a3 3 0 1 1 0-6C4.811 10.31 8.104 4.253 14 3.175V3a2 2 0 1 1 4 0zM18.83 27h-5.66a3.001 3.001 0 0 0 5.66 0M6.065 21H22v2H4a1 1 0 1 0 0 2h24a1 1 0 1 0 0-2h-1a1 1 0 0 1-.998-.945C25.36 10.517 21.989 5 16 5c-5.803 0-9.149 5.18-9.934 16z"
})));
export default SvgNotification;